import { SafetyAndSecurityRoundInPort } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const SAFETY_AND_SECURITY_ROUND_IN_PORT_DATA_TAG = 'SafetyAndSecurityRoundInPort';
export default class SafetyAndSecurityRoundInPortParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.IN_PORT_SAFETY_AND_SECURITY, FIXED_PROTOCOL_CONTENT_TYPE_IDS.IN_PORT_SAFETY_AND_SECURITY, SAFETY_AND_SECURITY_ROUND_IN_PORT_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            portName: 'portName',
            freeText: 'freeText',
            marSecLevel: 'marSecLevel',
        };
    }
    createData(props) {
        return new SafetyAndSecurityRoundInPort(props.portName, props.freeText, props.marSecLevel);
    }
}
//# sourceMappingURL=SafetyAndSecurityRoundInPortParser.js.map